// Ticket #268311: elke sessie wordt bewaard in zowel de nieuwe (sjabloon-rapportages) als de oude
// (rapportage-sjablonen) opslag. Rapportage controle toonde beide, dus dezelfde sessie stond twee keer in
// de lijst (de oude variant met één samengevoegde tekst en placeholder-momenten).
// Deze sleutel identificeert "dezelfde sessie": cliënt + begeleider + datum (hoofdletterongevoelig).
const norm = (v) => (v || '').toString().trim().toLowerCase();

export function rapportageSleutel(rap) {
  return `${norm(rap && rap.client_naam)}|${norm(rap && rap.begeleider_naam)}|${(rap && rap.datum) || ''}`;
}

// Geeft de oude rapportages terug die NIET al als nieuwe rapportage bestaan.
export function oudeZonderNieuweTweeling(nieuweRapportages, oudeSjablonen) {
  const nieuweSleutels = new Set((nieuweRapportages || []).map(rapportageSleutel));
  return (oudeSjablonen || []).filter((s) => !nieuweSleutels.has(rapportageSleutel(s)));
}
